import { useMemo as r } from "react";
import { useKioskLanding as i } from "../context.js";
function m() {
  const { configuration: n } = i();
  return r(() => {
    if (!n)
      return {
        services: [],
        groupedMenus: {}
      };
    const o = n.common.settings.menus.reduce((e, s) => (e[s.serviceType] || (e[s.serviceType] = []), e[s.serviceType].push(s), e), {});
    return {
      services: Object.keys(o).map(Number),
      groupedMenus: o
    };
  }, [n]);
}
export {
  m as useKioskMenus
};
//# sourceMappingURL=useKioskMenus.js.map
